export const NewReservationAction = () => ({
  label: "New Reservation",
  icon: "calendar-plus",
  iconStyle: "solid",
  href: (row) => row.newReservationPath,
})

export const NewContractAction = ({ onClickSingle }) => ({
  label: "New Contract",
  icon: "file-contract",
  iconStyle: "solid",
  onClickSingle,
})

export const ArchiveContactBoatAction = ({ onClickSingle }) => ({
  label: "Archive",
  icon: "box-archive",
  iconStyle: "solid",
  danger: true,
  onClickSingle,
  confirm: {
    title: "Archive boat",
    message: (row) => `Are you sure you want to archive ${row.name}?`,
    confirmLabel: "Archive",
  },
})

export const RestoreContactBoatAction = ({ onClickSingle }) => ({
  label: "Restore",
  icon: "rotate-left",
  iconStyle: "solid",
  onClickSingle,
  disabled: (row) => row.contactArchived,
})
